import { OhsUser } from 'user/OhsUser';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';
import { withCreatePermission, withViewPermission } from 'global-services/OhsPermission';
import { ModuleConfig } from 'global-services/constants/OhsObject';

const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.Injury}/${path}`,
  permission,
});
const commonPermission = (user: OhsUser) => {
  return (
    user?.configs?.injurymgmt?.PERMISSIONS.view_template ||
    user?.configs?.injurymgmt?.PERMISSIONS.view_master_record ||
    user?.configs?.injurymgmt?.PERMISSIONS.view_submaster_record ||
    false
  );
};

const OhsInjuryMgmtRouteList = {
  [ModuleRoute.Home]: createRoute('home', commonPermission),

  // FOLDER
  [ModuleRoute.FolderView]: createRoute('folder/:id/view', (user: OhsUser) =>
    withViewPermission(user, ModuleConfig.Injury, 'PERMISSIONS.view_master_record')
  ),
  [ModuleRoute.Details]: createRoute('view', commonPermission),

  [ModuleRoute.FolderAdd]: createRoute('folder/add', (user: OhsUser) =>
    withCreatePermission(user, ModuleConfig.Injury, 'PERMISSIONS.create_master_record')
  ),
  [ModuleRoute.FolderEdit]: createRoute(
    'folder/:id/edit',
    (user: OhsUser) => user?.configs?.injurymgmt?.PERMISSIONS.edit_master_record || false
  ),

  // TEMPLATE
  [ModuleRoute.TemplateView]: createRoute('template/:id/view', (user: OhsUser) =>
    withViewPermission(user, ModuleConfig.Injury, 'PERMISSIONS.view_template')
  ),
  [ModuleRoute.TemplateAdd]: createRoute('template/add', (user: OhsUser) =>
    withCreatePermission(user, ModuleConfig.Injury, 'PERMISSIONS.create_template')
  ),
  [ModuleRoute.TemplateAddMaster]: createRoute('template/add/master', (user: OhsUser) =>
    withCreatePermission(user, ModuleConfig.Injury, 'PERMISSIONS.create_template')
  ),
  [ModuleRoute.TemplateEditMaster]: createRoute('template/:id/edit/master', (user: OhsUser) =>
    withCreatePermission(user, ModuleConfig.Injury, 'PERMISSIONS.edit_master_template')
  ),
  [ModuleRoute.TemplateEdit]: createRoute(
    'template/:id/edit',
    (user: OhsUser) =>
      user?.configs?.injurymgmt?.PERMISSIONS.edit_master_template ||
      user?.configs?.injurymgmt?.PERMISSIONS.edit_template ||
      false
  ),
  [ModuleRoute.TemplateTaskAdd]: createRoute(
    'template/task-form/add',
    (user: OhsUser) => user.configs.injurymgmt?.PERMISSIONS?.create_template || false
  ),
  [ModuleRoute.TemplateTaskEdit]: createRoute(
    'template/task-form/:taskId/edit',
    (user: OhsUser) => user.configs.injurymgmt?.PERMISSIONS?.edit_template || false
  ),
  [ModuleRoute.TemplateTaskView]: createRoute(
    'template/task-form/:taskId/view',
    (user: OhsUser) => user.configs.injurymgmt?.PERMISSIONS?.view_template || false
  ),

  // RECORD
  // [ModuleRoute.Add]: createRoute('add', commonPermission),
  // [ModuleRoute.Edit]: createRoute('/:id/edit', commonPermission),

  [ModuleRoute.RecordView]: createRoute('record/:id/view', (user: OhsUser) =>
    withViewPermission(user, ModuleConfig.Injury, 'PERMISSIONS.view_submaster_record')
  ),
  [ModuleRoute.RecordAdd]: createRoute('record/:folderId/add', (user: OhsUser) =>
    withCreatePermission(user, ModuleConfig.Injury, 'PERMISSIONS.create_submaster_record')
  ),
  [ModuleRoute.RecordEdit]: createRoute(
    'record/:folderId/edit/:recordId',
    (user: OhsUser) => user?.configs?.injurymgmt?.PERMISSIONS?.edit_submaster_record || false
  ),
  [ModuleRoute.Evidence]: createRoute('record/:id/task/:taskId/completed', (user: OhsUser) =>
    withViewPermission(user, ModuleConfig.Injury, 'PERMISSIONS.view_submaster_record')
  ),
  [ModuleRoute.SignOff]: createRoute(
    'record/:id/task/:taskId/sign-off',
    (user: OhsUser) =>
      (user?.configs?.injurymgmt?.PERMISSIONS?.signoff &&
        user?.configs?.injurymgmt?.PERMISSIONS?.view_submaster_record) ||
      false
  ),
};

export default OhsInjuryMgmtRouteList;
